<template>
    <div>
        <div class="el-cal-item">
            <div class="el-cal-item__title">
                <div class="el-cal-item__title-text">
                    <div class="el-cal-item__time-slot">
                        {{
                            (booking.DateFrom &&
                                booking.DateFrom.toFormat('HH:mm')) ||
                                booking.start.format('HH:mm')
                        }}
                        -
                        {{
                            (booking.DateTo &&
                                booking.DateTo.toFormat('HH:mm')) ||
                                booking.end.format('HH:mm')
                        }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'booking-create-event',

    props: {
        booking: {
            type: Object,
            default: () => null,
        },

        element: {
            type: Object,
            default: () => null,
        },
    },

    mounted() {
        this.addStyles()
    },

    methods: {
        addStyles() {
            this.element.css('background', '#FEA47F')
            this.element.css('border-width', '2px')
            this.element.css('border-color', '#FFFFFF')
        },
    },
}
</script>
